// 在线数据设备
import request from '@/utils/request';
export function onlineDatadv(data) {
  return request({
    url: '/data/device_online_data',
    method: 'get',
    params: data
  });
}